import { __decorate } from "tslib";
import { Mixins, Component, Prop, Inject } from 'vue-property-decorator';
import { FacebookBusinessLoginProvider } from '@/helpers/entities/classes/providers/FacebookBusinessLoginProvider';
import FacebookBusinessLogin from '@/plugins/graphql/mutations/facebook-business-login.gql';
import FacebookBusinessLogout from '@/plugins/graphql/mutations/facebook-business-logout.gql';
import AlertMixin from '@/helpers/vue_mixins/AlertMixin';
import ButtonLoaderMixin from '@/helpers/vue_mixins/ButtonLoaderMixin';
// Initialize class FacebookLoginProvider
const Provider = new FacebookBusinessLoginProvider();
let FbBusinessLoginButton = class FbBusinessLoginButton extends Mixins(AlertMixin, ButtonLoaderMixin) {
    get buttonLabel() {
        return this.isLoggedIn ? 'Disconnect FB Business Account' : 'Facebook Business Messaging Login';
    }
    async logout() {
        this.requestOnFlight();
        await this.$apollo
            .mutate({
            mutation: FacebookBusinessLogout,
            variables: {
                input: {
                    appUuid: this.$route.params.appUUID,
                },
            },
        })
            .then(({ data }) => {
            if (data.facebookBusinessLogout.success) {
                this.successNotification('Business Logout Successful');
                this.$emit('businessLoggedOut');
                return;
            }
            this.errorNotification('An error has occured. Please inform the administrators.');
        })
            .catch((e) => {
            this.errorNotification(e.message);
        });
        this.requestDone();
    }
    async openFbLoginDialog() {
        const signInResult = await Provider.signIn()
            .then((response) => {
            const code = response?.authResponse?.code;
            return {
                success: true,
                code,
            };
        })
            .catch((e) => {
            this.errorNotification(e.message);
            return {
                success: false,
                code: '',
            };
        });
        let businessLoginSuccess = false;
        if (signInResult.success && signInResult.code) {
            businessLoginSuccess = await this.businessLoginMutation(signInResult.code)
                .then(({ data }) => {
                if (data.facebookBusinessLogin.success) {
                    this.successNotification('Business Login Successful');
                    this.$emit('businessLoggedIn');
                    this.requestDone();
                    return true;
                }
                this.errorNotification('An error has occured. Please inform the administrators.');
                this.requestDone();
                return false;
            })
                .catch((e) => {
                this.errorNotification(e.message);
                this.requestDone();
                return false;
            });
        }
        if (this.$route.name?.includes('overview') && businessLoginSuccess) {
            if (this?.appTaskQueryRefetch) {
                this.appTaskQueryRefetch();
            }
        }
    }
    businessLoginMutation(token) {
        this.requestOnFlight();
        return this.$apollo.mutate({
            mutation: FacebookBusinessLogin,
            variables: {
                input: {
                    token,
                    appUuid: this.$route.params.appUUID,
                },
            },
        });
    }
};
__decorate([
    Inject()
], FbBusinessLoginButton.prototype, "appTaskQueryRefetch", void 0);
__decorate([
    Prop()
], FbBusinessLoginButton.prototype, "styles", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], FbBusinessLoginButton.prototype, "isLoggedIn", void 0);
FbBusinessLoginButton = __decorate([
    Component({
        mounted() {
            // Call #initialize function to append facebook sdk into DOM head
            Provider.initialize();
        },
    })
], FbBusinessLoginButton);
export default FbBusinessLoginButton;
